import { useMutation } from '@tanstack/react-query';
import request from '@utils/request';
import { Dispatch, SetStateAction } from 'react';

export const useRemoveVoucherCode = (
  propertyId: number,
  basketId: string,
  onSuccess: () => Promise<void>,
  setError: Dispatch<SetStateAction<string | null>>
) => {
  return useMutation({
    mutationFn: async (code: string) => {
      const encodedCode = encodeURIComponent(code.trim());
      return await request.v2.delete(`${propertyId}/baskets/${basketId}/vouchers/${encodedCode}`);
    },
    onSuccess,
    onError: () => {
      setError('basket.errorApplyingCodeInvalid');
    },
  });
};
